import type { LandmarkDef } from './common';
import { landmarkModel } from './model';

/**
 * landmarks/patagonia.ts — Patagonia's landmarks, all hand-built low-poly Blender
 * models (glTF). The estancia gate is a drive-through ('span') scaled by width.
 */
export const PATAGONIA_LANDMARKS: Record<string, LandmarkDef> = {
  // GS7: the board's EL CHALTEN lettering now fronts BOTH faces (it only ever
  // read from behind — the mirrored-sign class), and the steer skull moved off
  // the lettering onto the header beam as a proper crest.
  estanciaGate: { build: (hw) => landmarkModel('models/landmarks/estancia_gate.glb', { width: 2 * hw + 18 }), placement: 'span' },
  // GS7: rebuilt as a calving serac face (irregular ice towers over a continuous
  // glacier body, so fissures read as ice and never sky) with the icicle fringe
  // sunk into the overhanging lips. Its crevice depth is baked into COLOR_0 —
  // vertex colours only DARKEN baseColor, so the ice base is authored bright and
  // carved down toward glacial blue. Dropping COLOR_0 flattens it to a pale slab.
  glacierWall: { build: () => landmarkModel('models/landmarks/glacier_wall.glb', { height: 26 }), placement: 'side', offset: 30 },
  // M97: the massif's skirt is ~96 units deep — anchored past the COURSE END so
  // the rock starts beyond the end barrier instead of under the coasting cars.
  // GS7: the towers are real granite grey now with white confined to the summit
  // caps (the snow shells wrapped the top 40% and the whole massif read as one
  // snow cone), and the skirt's foot carries a COLOR_0 ramp toward the sage
  // terrain so it no longer meets the ground on a hard seam behind the gantry.
  fitzRoy: { build: () => landmarkModel('models/landmarks/fitz_roy.glb', { height: 95 }), placement: 'finish', ahead: 118 },
};
